/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
  constructor() {

    const elements = Array.prototype.slice.call(document.querySelectorAll('.site .ns-table-wrap, .site .mms-title-h1, .site .mms-title-h2, .site .mms-title-h3, .site .accordion__title, .site .mms-title-h4'));

    let h1;
    let h2;
    let h3;
    let h4;
    let c;
    let pageTitle = document.querySelector('[class*="mms-title-"]');

    elements.forEach(element => {
      const className = element.classList[0];

      switch (className) {
        case "mms-title-h1":
          h1 = element.innerText;
          c = 0;
          break;
        case "mms-title-h2":
          if (!!element.innerText.trim()) {
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "mms-title-h3":
          if (!!element.innerText.trim()) {
            h3 = element.innerText;
            c = 0;
          }
        case "mms-title-h4":
          if (!!element.innerText.trim()) {
            h4 = element.innerText;
            c = 0;
          }


          break;
        case "accordion__title":
          const spanL = element.querySelector('span:last-child');
          if (!!spanL && !!spanL.innerText.trim()) {
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';
          if (!!pageTitle) {
            title += pageTitle.innerText + ' – ';
          }
          if (!!h1) {
            title += h1.trim();
          }
          if (!!h2) {
            title += ' - ' + h2.trim();
            fileTitle += h2.trim().replace(/\s/g, '_');
          } else {
            fileTitle += h1.trim().replace(/\s/g, '_');
          }
          if (c > 0) {
            title += ' ' + (c + 1);
            fileTitle += '_' + (c + 1);
          }
          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          element.dataset.xFileTitle = fileTitle.toLowerCase();
          c++;
          break;
      }
      // ifelement.
    });
  }
}

export default XTableNamer;
